import { Button, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";
import React, { useEffect, useRef, useState } from "react";
import SideBar from "../SideBar/SideBar";
import "./Support.css";
import Box from "@mui/material/Box";
import WidgetsIcon from "@mui/icons-material/Widgets";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import Avatar from "@mui/material/Avatar";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import Stack from "@mui/material/Stack";
import AddIcon from "@mui/icons-material/Add";
import Badge from "@mui/material/Badge";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
// import Loader from "../Loader";
import zec from "../../Images/profile-img-2.webp";
import profile from "../../Images/profile-img-1.webp";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import { ToastContainer, toast } from "react-toastify";

import Loader from "../Loader";
import {
  createChat,
  createSocket,
  createTicket,
  getChats,
  getTickets,
} from "../../services/Support";
import { io } from "socket.io-client";
import dayjs from "dayjs";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 500,
  bgcolor: "var(--support)",
  boxShadow: 24,
  p: 3,
  borderRadius: 2,
  "@media(max-width:575.98px)": {
    width: "80%",
  },
};

const Support = () => {
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const isLgUp = useMediaQuery(theme.breakpoints.up("sm"));
  const drawerWidth = 300;

  const [chat, setChat] = useState([
    {
      name: "Bharath",
      noftify: "Hi bharath How are you doing long time no see",
      img: profile,
    },
    {
      name: "Anbu",
      noftify: "Hi anbu How are you doing long time no see",
      img: profile,
    },
    {
      name: "Alan",
      noftify: "Hi alan How are you doing long time no see",
      img: profile,
    },
    {
      name: "Sinu",
      noftify: "Hi sinu How are you doing long time no see",
      img: profile,
    },
    {
      name: "Nandhini",
      noftify: "Hi nandhini How are you doing long time no see",
      img: zec,
    },
    {
      name: "Vinoth",
      noftify: "Hi vinotth sir How are you doing long time no see",
      img: profile,
    },
    {
      name: "Santhosh",
      noftify: "Hi Santhosh bro How are you doing long time no see",
      img: profile,
    },
  ]);
  //personal chat

  const [perChat, setPerChat] = useState([]);

  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  // const handleClose = () => setOpen(false);

  const handleClose = () => {
    setOpen(false);
    setErrors({});
  };

  const [search, setSearch] = useState();

  const [message, setMessage] = useState([]);

  const [updated, setUpdated] = useState("");

  const [movileView, setMovileView] = useState(false);

  const handleChangeSend = (event) => {
    setUpdated(event.target.value);
  };

  const handleEnterKeyPress = (e) => {
    if (e.key === "Enter") {
      handleClickSend();
    }
  };

  const handleClickSend = async (e) => {
    // 👇 "message" stores input field value

    // if (updated?.trim() !== "") {
    //   setMessage([...message, updated]);
    //   setUpdated("");
    // }
    // e.preventDefault();
  
    const data = {
      message: updated?.trim(),
      ticketId: ticketId,
      speaker: "user",
      imageUrl: imageUrl || null, 
      // to: "admin",
    };
    if (imageUrl) {
      data.imageBlob = URL.createObjectURL(imageUrl); // Use the blob for preview
    }


    if (updated?.trim() != "") {
      const room = "678914a3ecaba0b27b1be2be";
      const messagesocket = {
        message: updated.trim(),
        ticketId: ticketId,
        senderId: token?.userId, // Ensure you're sending the correct senderId
        receiverId: "678914a3ecaba0b27b1be2be", // This should be the receiver's ID
        speaker: "user",
        imageUrl: imageUrl || null,
        // to: "admin",
      };
      socket.emit("send_message", messagesocket, room);

      const messageset = {
        speaker: "user",
        message: updated.trim(),
        imageUrl: imageUrl || null,
      };
      if (imageUrl) {
        messageset.imageUrl = data.imageBlob; // Use the blob URL for local preview
      }

      setAllChats([...allChats, messageset]);
      setUpdated("");
      setImageUrl(null); 

      setLoad(true);
      const response = await createChat(data);
      if (response?.data?.success === true) {
        // toast.success(response.data.message);
        setUpdated("");
        setLoad(false);
      } else {
        toast.error(response?.data?.message);
        setLoad(false);
      }
    }
  };

  const handleDeleteTodo = (index) => {
    const newTodos = [...message];
    newTodos.splice(index, 1);
    setMessage(newTodos);
  };

  //image upload

  const [imageUrl, setImageUrl] = useState(null);

  const handleImageUpload = (event) => {
    console.log("dreiruer",event.target.files)
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageUrl(reader.result); // This will store the image URL
      const messageset = {
        speaker: "user",
        message: updated.trim(),
        imageUrl: reader.result || null,
      };
  
      setAllChats([...allChats, messageset]);
    };
    if (file) {
      reader.readAsDataURL(file);
    }
   
  };

  
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [ticketId, setTicketId] = useState("");

  const handleToggle = () => {
    setIsCollapsed(!isCollapsed);
  };

  const handleChatData = (val) => {
    setPerChat(val);
    setTicketId(val?.ticketId);
    getVoiceChats(val?.ticketId);
    if (!isCollapsed && matches) {
      // handleToggle()
    } else {
      setMovileView(true);
    }
  };

  //new records
  const [allTickets, setAllTickets] = useState({
    title: "",
    reason: "",
  });
  const [load, setLoad] = useState(false);
  const [errors, setErrors] = useState({
    title: "",
    reason: "",
  });

  const [tickets, setTickets] = useState([]);

  const [allChats, setAllChats] = useState([]);
  const[isLoading,setIsLoading]=useState(true);

  useEffect(() => {
    getAllTickets();
  }, []);

  const getAllTickets = async () => {
    setIsLoading(true);
    const response = await getTickets();
    if (response?.data?.success === true) {
      setTickets(response.data.result);
      setIsLoading(false);
    } 
  };

  const getVoiceChats = async (ticketId) => {
    // setIsLoading(true)
    const response = await getChats(ticketId);
    if (response?.data?.success === true) {
      setAllChats(response.data.result);
      // setIsLoading(false)
    } 
  };

  // const token = localStorage.getItem("Token");
  const data = localStorage.getItem("UserDetails");
  const token = JSON.parse(data);

  const [socket, setSocket] = useState(null);

  // const socket = io("http://localhost:9001");




  useEffect(() => {
    const socketConnection = io("http://192.168.1.52:9001", {
      query: { token: token.userId }, // Send the token as a query parameter
    });

    setSocket(socketConnection);
    socketConnection.on("connect", () => {
      console.log("Connected to server!");
      socketConnection.emit("register", token?.userId); // Register with userId after connection
    });
    socketConnection.on("receive_message", (data) => {
      if (!data) {
      } else {
        // if (data?.fromId === token?.userId) {
        const datas = {
          speaker: "admin",
          message: data.message,
        };

        // setAllChats([...allChats, datas]);
        setAllChats((prevMessages) => [...prevMessages, datas]);
        // }
      }
    });

    // // Clean up event listeners
    return () => {
      socketConnection.off("connect");
      socketConnection.off("receive_message");
    };
   
  }, []);

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setAllTickets({ ...allTickets, [name]: value });
  };

  const validateFocus = (e) => {
    const fieldName = e?.target?.name;
    const fieldValue = e?.target?.value;
    const value = fieldValue.trim();

    let isValid = true;
    let errorMessage = "";

    // Handle email validation
    if (fieldName === "title") {
      if (value != "" && value.length < 5) {
        errorMessage = "Title must be at least 5 characters long";
        isValid = false;
      }
    }
    if (fieldName === "reason") {
      if (value != "" && value.length < 5) {
        errorMessage = "Reason must be at least 5 characters long";
        isValid = false;
      }
      else if(/^\d{0,49}$/.test(value)){
        e.preventDefault();
         errorMessage = "only allow 50 characters";
        isValid = false;
      }
    }

    setErrors((prevErrors) => ({
      ...prevErrors,
      [fieldName]: errorMessage,
    }));

    return isValid;
  };

  const validate = () => {
    let formErrors = {};
    let isValid = true;

    // Validate email
    if (!allTickets.title) {
      formErrors.title = "Title is required";
      isValid = false;
    } else if (allTickets.title?.length < 5) {
      formErrors.title = "Title must be at least 5 characters long";
      isValid = false;
    }

    // Validate password
    if (!allTickets.reason) {
      formErrors.reason = "Reason is required";
      isValid = false;
    } else if (allTickets.reason.length < 6) {
      formErrors.reason = "Reason must be at least 6 characters long";
      isValid = false;
    }

    setErrors(formErrors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setLoad(true);

      const response = await createTicket(allTickets);
      if (response?.data?.success === true) {
        toast.success(response?.data?.message);
        setLoad(false);
        setOpen(false);
        getAllTickets();
      } else {
        toast.error(response?.data?.message);

        setLoad(false);
      }
    }
  };

  const formatTimestamp = (timestamp) => {
    return dayjs(timestamp).format("h:mm A"); // Format as "HH:mm A"
  };

  const containerRef = useRef(null);

  // Function to scroll fully to the bottom with smooth effect
  const scrollToBottom = () => {
    if (containerRef.current) {
      containerRef.current.scrollTo({
        top: containerRef.current.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  // Automatically scroll to the bottom when messages change
  useEffect(() => {
    scrollToBottom();
  }, [allChats]);

  const chatHistChat1 = (
    <div className="msglist cont-msg">
      <div
        className={
          matches && isCollapsed
            ? "msg-lsit-head display-3"
            : "msg-list-head display-2"
        }
      >
        <h3 className="chats cursor">
          {/* [] */}
          {matches && isCollapsed ? (
            <WidgetsIcon
              sx={{ fontSize: "25px !important", fill: "#7a7a7a" }}
              onClick={handleToggle}
            />
          ) : (
            "Ticket List"
          )}
        </h3>
        {!isCollapsed && matches ? (
          <div div className="msg-lsit-head-svg cursor">
            <Button onClick={handleOpen} className="create-btn display-1">
              Create <AddIcon />
            </Button>
          </div>
        ) : (
          <></>
        )}
      </div>

      <div className="sea-input mt-20">
        {!isCollapsed && (
          <form class="form">
            <label for="search">
              <input
                class="inputs"
                type="text"
                required=""
                placeholder="Search Ticket"
                id="search"
              />
              <div class="fancy-bg"></div>
              <div class="search">
                <svg
                  viewBox="0 0 24 24"
                  aria-hidden="true"
                  class="r-14j79pv r-4qtqp9 r-yyyyoo r-1xvli5t r-dnmrzs r-4wgw6l r-f727ji r-bnwqim r-1plcrui r-lrvibr"
                >
                  <g>
                    <path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path>
                  </g>
                </svg>
              </div>
            </label>
          </form>
        )}
      </div>

      <div className="msg-list-area padding-20">
        {/* 
      <div>
              <p className="display-1"> <ErrorOutlineIcon/> Yet no ticket raised!</p>
            </div> */}
        {tickets
          .filter((obj) => {
            return search?.toLocaleLowerCase() === undefined
              ? obj
              : obj.name.toLocaleLowerCase().includes(search);
          })
          .map((row, ind) => {
            return (
              <div
                className="display-2 mt-10 cursor messages-ticket-list"
                onClick={() => {
                  handleChatData(row);
                }}
                key={row?.ticketId}
              >
                <div key={ind} className="msg-list-chat-main display-1 ">
                  {/* <Badge
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    variant="dot"
                    className="online-bdg"
                  >
                    <div>
                      <Avatar
                        sx={{ width: 40, height: 40 }}
                        alt="Remy Sharp"
                        // src={row.img}
                      />
                    </div>
                  </Badge> */}
                  <div className="msg-list-chat-name">
                    {row.title}
                    <div
                      className="chat-desc display-4"
                      id="sentence"
                      style={{ width: "100%" }}
                    >
                      {row.reason?.length > 30
                        ? row.reason.substring(0, 28) + "..."
                        : row.reason}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );

  const pvtChat1 = (
    <div className="msglist">
      <div className="msg-list-head display-2 chat-head">
        <p>Chat</p>
      </div>

      <div className="colab-avatar-cont vr">
        <Stack direction="row" spacing={-0.5}>
          {
            <div div className="cursor">
              {!matches ? (
                <ArrowBackIosIcon
                  sx={{ fontSize: "25px !important", fill: "#7a7a7a" }}
                  onClick={() => {
                    movileView && setMovileView(false);
                  }}
                />
              ) : (
                <></>
              )}
            </div>
          }
          {/* <Avatar sx={{ width: 30, height: 30 }} alt="Remy Sharp" src={artist1} />
                    <Avatar sx={{ width: 30, height: 30 }} alt="Travis Howard" src={artist2} />
                    <Avatar sx={{ width: 30, height: 30 }} alt="Cindy Baker" src={artist3} /> */}
        </Stack>
      </div>
      <div className="colab-chat-area msg padding-20" ref={containerRef}>
        {/* <div className="chat-area-inner-text vr">
          <div>
            <Avatar
              sx={{ width: 30, height: 30 }}
              alt="Remy Sharp"
              src={perChat.img}
            />
          </div>
          <div className="collab-send-text-main">
            <div className="username">{perChat.name}(dev)</div>
            <div className="txt1">{perChat.noftify}</div>
            <div className="time">11:45am</div>
          </div>
        </div> */}
        {/* 
<div>
  <p>No Chat found!</p>
</div> */}

        {allChats?.length > 0 ? (
          allChats?.map((msg, ind) => {
            console.log("msg",msg)
            return (
              <div
                className="chat-area-inner-text user vr"
                style={{
                  justifyContent: msg.speaker === "user" ? "right" : "left",
                }}
                key={ind}
              >
                {/* <div>
                <Avatar
                  sx={{ width: 30, height: 30 }}
                  alt="Remy Sharp"
                  src={perChat.img}
                />
              </div>
              <div className="collab-send-text-main2 user">
                <div className="username">Me(dev)</div>
                <div className="txt1">{todo}</div>
                <div className="time">11:45am</div>
              </div> */}
                 

                <div className="collab-send-text-main">
                  <div
                    className="username"
                    style={{
                      textAlign: msg.speaker === "user" ? "right" : "left",
                    }}
                  >
                     {msg.imageUrl && (
                                <img
                                  src={msg.imageUrl} // Blob or URL
                                  alt="chat attachment"
                                  height={70} width={80}
                                  // style={{
                                  //   maxWidth: "200px",
                                  //   maxHeight: "200px",
                                  //   borderRadius: "8px",
                                  //   marginTop: "10px",
                                  // }}
                                />
                              )}
                    {" "}
                    {msg.message}
                    
                  </div>
                  {/* {msg.imageUrl && (
            <div className="message-image">
              <img src={msg.imageUrl} alt="Uploaded" height={70} width={80} />
            </div>
          )} */}

                  <div className="time"> {formatTimestamp(msg.time)}</div>
                </div>
              </div>
            );
          })
        ) : (
          <div>
            <p>No Chat found!</p>
          </div>
        )}
      </div>

      <div class="messageBox padding-20">
        <div class="fileUploadWrapper">
          <label for="file">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 337 337"
            >
              <circle
                stroke-width="20"
                stroke="#6c6c6c"
                fill="none"
                r="158.5"
                cy="168.5"
                cx="168.5"
              ></circle>
              <path
                stroke-linecap="round"
                stroke-width="25"
                stroke="#6c6c6c"
                d="M167.759 79V259"
              ></path>
              <path
                stroke-linecap="round"
                stroke-width="25"
                stroke="#6c6c6c"
                d="M79 167.138H259"
              ></path>
            </svg>
            <span class="tooltip">Add an image</span>
          </label>
          <input type="file" id="file" name="file" 
          // onChange={(e)=>handleImageUpload(e)}
          onChange={(e)=>setImageUrl(e.target.files[0])}
          />
        </div>
        {imageUrl && (
                    <div style={{ marginTop: "10px" }}>
                      <img
                        src={URL.createObjectURL(imageUrl)}
                        alt="Preview"
                        style={{ maxWidth: "200px", maxHeight: "200px", borderRadius: "8px" }}
                      />
                      <button onClick={() => setImageUrl(null)}>Remove</button>
                    </div>
                  )}
        <input
          required=""
          placeholder="Message..."
          type="text"
          id="messageInput"
          value={updated}
          onChange={handleChangeSend}
          onKeyDown={handleEnterKeyPress}
        />
        <button id="sendButton" onClick={handleClickSend}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 664 663"
          >
            <path
              fill="none"
              d="M646.293 331.888L17.7538 17.6187L155.245 331.888M646.293 331.888L17.753 646.157L155.245 331.888M646.293 331.888L318.735 330.228L155.245 331.888"
            ></path>
            <path
              stroke-linejoin="round"
              stroke-linecap="round"
              stroke-width="33.67"
              stroke="#6c6c6c"
              d="M646.293 331.888L17.7538 17.6187L155.245 331.888M646.293 331.888L17.753 646.157L155.245 331.888M646.293 331.888L318.735 330.228L155.245 331.888"
            ></path>
          </svg>
        </button>
      </div>
    </div>
  );

  // if(isLoading) return <Loader/>

  return (
    <>
      <ToastContainer autoClose={2000} />
      <div className="support-full">
     
        {/* <Loader/> */}
       
        {/* <Box sx={{ display: isLgUp ? "flex" : "block", marginTop: "20px" }}>
          <SideBar />
          <Loader />
          <Box
            component="main"
            sx={{
              flexGrow: 1,
              p: isLgUp ? 5 : 1,
              width: { sm: `calc(100% - ${drawerWidth}px)` },
              marginTop: isLgUp ? "0px" : "25px",
            }}
          > */}
            <Grid container spacing={2}>
              <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
                <Grid
                  container
                  spacing={2}
                  sx={{ justifyContent: "center", marginTop: "20px" }}
                  className="grid-responsive"
                >
                  {matches && (
                    <Grid
                      item
                      size={{ xs: 12, sm: 12, md: 6, lg: 8, xl: 9 }}
                      className=" "
                    >
                      {pvtChat1}
                    </Grid>
                  )}
                  <Grid
                    item
                    size={{ xs: 12, sm: 12, md: 6, lg: 4, xl: 3 }}
                    className=" "
                  >
                    {!matches && movileView ? pvtChat1 : chatHistChat1}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          {/* </Box>
        </Box> */}

        {/* ticket modal */}
        <Modal
          open={open}
          // onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <div className="close-icon new cursor">
              <HighlightOffIcon
                sx={{ fontSize: "30px" }}
                onClick={handleClose}
              />
            </div>
            <div className="create-ticket">
              <h2 style={{ color: "var(--clr-font)" }}>Create Ticket</h2>
            </div>
            <div className="create-field">
              <div className="email-fill">
                <div className="email-name mod">Title *</div>
                <TextField
                  margin="normal"
                  required
                  fullWidth
                  id="title"
                  // label="Email Address"
                  name="title"
                  // autoComplete="title"
                  autoFocus
                  onChange={handleChange}
                  onFocus={(e) => validateFocus(e)}
                  onInput={validateFocus}
                  error={!!errors.title}
                  helperText={errors.title}
                />
              </div>
              <div className="email-fill mt-10">
                <div className="email-name mod">Reason *</div>
                <TextField
                  id="outlined-multiline-static"
                  margin="normal"
                  fullWidth
                  multiline
                  rows={4}
                  name="reason"
                  required
                  onChange={handleChange}
                  onFocus={(e) => validateFocus(e)}
                  onInput={validateFocus}
                  error={!!errors.reason}
                  helperText={errors.reason}
                  inputProps={{
                    maxLength: 50,
                   
                  }}
                  // defaultValue="Default Value"
                />
              </div>
              <div className="common-btn mt-20 text-center">
                {/* <Button>Submit</Button> */}
                {load ? (
                  <Button fullWidth>Processing...</Button>
                ) : (
                  <Button
                    type="submit"
                    fullWidth
                    onClick={handleSubmit}
                    // onClick={() => {
                    //   navigate("/");
                    // }}
                  >
                    Submit
                  </Button>
                )}
              </div>
            </div>
          </Box>
        </Modal>
        {/* ticket modal */}
      </div>
    </>
  );
};

export default Support;
